var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E5E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1248 21.1521C18.2575 21.3695 18.4151 21.5753 18.5974 21.7651C19.7295 22.9432 21.4549 23.1274 22.7725 22.3176C23.0166 22.1675 23.2467 21.9834 23.4565 21.7651L26.4934 18.6044C27.8351 17.2079 27.8351 14.9438 26.4934 13.5474C25.1516 12.1509 22.9761 12.1509 21.6343 13.5474L20.9654 14.2435",
    stroke: "#3D4AF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0346 25.7562L18.3654 26.4526C17.0237 27.8491 14.8482 27.8491 13.5064 26.4526C12.1645 25.0561 12.1645 22.7921 13.5064 21.3956L16.5433 18.2349C17.8851 16.8384 20.0606 16.8384 21.4024 18.2349C21.5847 18.4246 21.7422 18.6303 21.8749 18.8476",
    stroke: "#3D4AF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.e57ebec268223ee179194382c904dc7c.svg";
export { ForwardRef as ReactComponent };